export default "__VITE_ASSET__BvXK2bd7__"